import script from "./ChangeStatusProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeStatusProcess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__